import Header from 'components/common/Header';
import SidebarTemplate from 'components/common/SidebarTemplate';
import styled, { css } from 'styled-components';
import { Outlet } from 'react-router-dom';
import useCheckAuth from 'hooks/common/useCheckAuth';
import { useCheckPartner } from 'hooks/common/useCheckPartner';

const AdminPage = () => {
  const isCheck = useCheckAuth('0');

  useCheckPartner();

  return (
    <AdminPageBlock isCheck={isCheck}>
      <Header />
      <SidebarTemplate>
        <Outlet />
      </SidebarTemplate>
    </AdminPageBlock>
  );
};
export default AdminPage;

const AdminPageBlock = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  ${props =>
    !props.isCheck &&
    css`
      visibility: hidden;
    `}
`;
